import { gql, graphQueryBang } from "../../../shared/lib/graphql"

const IngredientFragment = `
  id
  name
  slug
  note
  value_type
  example
  target_query { id }
  weight
`

const replaceFragments = query =>
  query.replace(/INGREDIENT_FRAGMENT/g, IngredientFragment)

const QueryIngredientsQuery = replaceFragments(gql`
  query QueryIngredientsQuery($query_id: String!) {
    query(module_name: $query_id) {
      ingredients {
        INGREDIENT_FRAGMENT
      }
    }
  }
`)

const IngredientAddMutation = replaceFragments(gql`
  mutation IngredientAddMutation(
    $parent_id: ID!
    $parent_type: String!
    $name: String!
    $slug: String!
    $note: String!
    $value_type: String!
    $example: String!
    $target_query_id: ID
  ) {
    ingredientCreate(
      input: {
        parent_id: $parent_id
        parent_type: $parent_type
        name: $name
        slug: $slug
        note: $note
        value_type: $value_type
        example: $example
        target_query_id: $target_query_id
      }
    ) {
      ingredient {
        INGREDIENT_FRAGMENT
      }
      errors {
        attribute
        message
      }
    }
  }
`)

const IngredientUpdateMutation = replaceFragments(gql`
  mutation IngredientUpdateMutation(
    $id: ID!
    $name: String!
    $slug: String!
    $note: String!
    $value_type: String!
    $example: String!
    $target_query_id: ID
    $weight: Int
  ) {
    ingredientUpdate(
      input: {
        id: $id
        name: $name
        slug: $slug
        note: $note
        value_type: $value_type
        example: $example
        target_query_id: $target_query_id
        weight: $weight
      }
    ) {
      ingredient {
        INGREDIENT_FRAGMENT
      }
      errors {
        attribute
        message
      }
    }
  }
`)

const IngredientDeleteMutation = gql`
  mutation IngredientDeleteMutation($id: ID!) {
    ingredientDelete(input: { id: $id }) {
      errors {
        attribute
        message
      }
    }
  }
`

export function getQueryIngredients(query) {
  return graphQueryBang(QueryIngredientsQuery, {
    query_id: query.id,
  }).then(data => data.query.ingredients)
}

export function ingredientAdd(parent_id, parent_type, ingredient) {
  return graphQueryBang(IngredientAddMutation, {
    parent_id,
    parent_type,
    name: ingredient.name,
    slug: ingredient.slug,
    note: ingredient.note,
    value_type: ingredient.valueType,
    example: ingredient.example,
    target_query_id: ingredient.targetQueryId,
  }).then(data => data.ingredientCreate)
}

export function ingredientUpdate(ingredient) {
  return graphQueryBang(IngredientUpdateMutation, {
    id: ingredient.id,
    name: ingredient.name,
    slug: ingredient.slug,
    note: ingredient.note,
    value_type: ingredient.valueType || ingredient.value_type,
    example: ingredient.example,
    target_query_id:
      ingredient.targetQueryId ||
      (ingredient.target_query && ingredient.target_query.id),
    weight: ingredient.weight,
  }).then(data => data.ingredientUpdate)
}

export function ingredientDelete(ingredient) {
  return graphQueryBang(IngredientDeleteMutation, {
    id: ingredient.id,
  }).then(data => data.ingredientDelete)
}
